import StreamerBoxIcon from '@app/modules/fleet/legacy/components/StreamerBoxIcon';
import { AppModule } from '@app/types';

/**
 * Fleet module: Balena device listing and legacy Stream Box screens.
 */
export const FleetModule: AppModule = {
  id: 'fleet',
  icon: <StreamerBoxIcon />,
  title: 'Devices',
  basePath: 'devices',
};
